/* Protection des cadeaux de l'offre : un cadeau (propriété _bundle = "offre-N-cadeau") ne doit jamais être facturé.
   Si la remise « Achète X, obtiens Y » ne s'applique plus (ex. le client retire un soutien-gorge), on retire le cadeau. */
(function () {
  'use strict';
  var busy = false;

  function isGift(item) {
    return !!(item.properties && /-cadeau$/.test(String(item.properties._bundle || '')));
  }
  function paidGifts(cart) {
    return (cart && cart.items ? cart.items : []).filter(function (i) { return isGift(i) && i.final_line_price > 0; });
  }

  function enforce(cart) {
    if (busy) return;
    var source = cart && cart.items
      ? Promise.resolve(cart)
      : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });

    source.then(function (c) {
      var bad = paidGifts(c);
      if (!bad.length) return null;
      busy = true;
      var updates = {};
      bad.forEach(function (i) { updates[i.key] = 0; });
      var sections = [];
      try {
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
      } catch (e) { /* sans conséquence */ }
      var body = { updates: updates };
      if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (fresh) {
          if (window.theme && theme.pubsub && fresh && fresh.items) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'gift-guard', cart: fresh });
          }
        });
    })
      .catch(function () { /* on réessaiera à la prochaine mise à jour du panier */ })
      .then(function () { busy = false; });
  }

  function start(tries) {
    if (window.theme && theme.pubsub && theme.pubsub.subscribe) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source !== 'gift-guard') enforce(event.cart);
      });
      if (/(^|;\s*)cart=/.test(document.cookie)) enforce(null);
      return;
    }
    if (tries < 40) setTimeout(function () { start(tries + 1); }, 250);
  }

  start(0);
})();
